import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import store from '@state/store'
import { asset } from '@modules/consolidator/constants/URL'
import { aporte } from '@constants/URL'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import { stampConsolidatorEvents } from '@modules/consolidator/utils/Events/Events'
import {
  shouldUseCachedData,
  cloneDefensive,
  dedupeInFlight,
} from '@modules/consolidator/utils/Api/Api'

const CLIENT_SCOPE = 'self'

class APIConsolidatorEvents extends APITemplate {
  constructor() {
    super()
    this.proventosRegistry = {}
    this.splitsRegistry = {}
  }

  async salvar({ id_ativo, lista, tipo }) {
    const data = { data: JSON.stringify(lista) }
    if (tipo) {
      data.tipo = tipo
    }
    const r = await con.put(asset.events + `/${id_ativo}`, data)
    return r || {}
  }

  carregarProventos({ idCliente, isCliente = false, forceUpdate = false } = {}) {
    if (!isCliente && !idCliente) {
      return { status: 404, message: 'Cliente não encontrado.', value: {} }
    }

    const scope = isCliente ? CLIENT_SCOPE : idCliente

    if (
      store.getters['consolidator/proventosClientId'] === scope &&
      shouldUseCachedData({
        forceUpdate,
        lastUpdate: store.getters['consolidator/proventosLastUpdate'],
        timeoutMinutes: MINUTES_TIMEOUT_REQUESTS,
      })
    ) {
      return {
        status: 200,
        message: 'Proventos em cache',
        value: cloneDefensive({
          payload: store.getters['consolidator/proventos'],
          fallback: {},
        }),
      }
    }

    return dedupeInFlight({
      registry: this.proventosRegistry,
      key: scope,
      run: () => this.fetchProventos(scope),
    })
  }

  async fetchProventos(scope) {
    const url =
      scope === CLIENT_SCOPE
        ? aporte.client.profits
        : aporte.professional.profits + scope

    store.dispatch('consolidator/setProventosLoading', true)
    const r = await con.get(url)
    const data =
      r && r.status === 200
        ? stampConsolidatorEvents({ map: r.value, type: 'provento' })
        : {}
    store.dispatch('consolidator/setProventos', { data, clientId: scope })
    store.dispatch('consolidator/setProventosLoading', false)

    return r || { status: 500, message: 'Erro inesperado', value: {} }
  }

  carregarSplits({ idCliente, isCliente = false, forceUpdate = false } = {}) {
    if (!isCliente && !idCliente) {
      return { status: 404, message: 'Cliente não encontrado.', value: {} }
    }

    const scope = isCliente ? CLIENT_SCOPE : idCliente

    if (
      store.getters['consolidator/splitsClientId'] === scope &&
      shouldUseCachedData({
        forceUpdate,
        lastUpdate: store.getters['consolidator/splitsLastUpdate'],
        timeoutMinutes: MINUTES_TIMEOUT_REQUESTS,
      })
    ) {
      return {
        status: 200,
        message: 'Splits em cache',
        value: cloneDefensive({
          payload: store.getters['consolidator/splits'],
          fallback: {},
        }),
      }
    }

    return dedupeInFlight({
      registry: this.splitsRegistry,
      key: scope,
      run: () => this.fetchSplits(scope),
    })
  }

  async fetchSplits(scope) {
    const url =
      scope === CLIENT_SCOPE
        ? aporte.client.splits
        : aporte.professional.splits + scope

    store.dispatch('consolidator/setSplitsLoading', true)
    const r = await con.get(url)
    const data =
      r && r.status === 200
        ? stampConsolidatorEvents({ map: r.value, type: 'split' })
        : {}
    store.dispatch('consolidator/setSplits', { data, clientId: scope })
    store.dispatch('consolidator/setSplitsLoading', false)

    return r || { status: 500, message: 'Erro inesperado', value: {} }
  }
}

const apiConsolidatorEvents = new APIConsolidatorEvents()
export { apiConsolidatorEvents }
